var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorderinline = function SvgBorderinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 1,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    width: 26,
    height: 1,
    rx: 0.5,
    stroke: "#fff"
  })));
};

export default SvgBorderinline;